/* eslint-disable */
import { mapState } from 'vuex'
import { getCookie } from '@/utils/tool'
import {
  async_task_query,
  batch_delete_task,
  delete_task,
  submit_batch_task,
  view_task_result_detail
} from '@/services/asyncTask'
import { ASYNC_TASK_MAP, ASYNC_TASK_TYPE } from '@/config/asyncTask'

const ASYNC_TASK_STATUS = {
  create: 0, // 已创建
  pending: 1, // 等待中
  preparing: 2, // 准备中
  prepared: 3, // 已准备
  running: 4, // 运行中
  success: 5, // 已成功
  failed: 6, // 已失败
  deleted: 7 // 已删除
}

Object.freeze(ASYNC_TASK_STATUS)

export default {
  data() {
    return {
      ASYNC_TASK_STATUS,
      ASYNC_TASK_TYPE,
      ASYNC_TASK_MAP,
      panelStatus: false,
      unfinished: 0, // 当前正在执行的数量
      error: 0, // 执行失败的数量
      total: 0, // 总任务数
      taskList: [],
      timer: null, // 轮询异步任务的定时器
      GAP_INTERVAL: 5000,
      intervalTimes: 0, // 轮询次数
      deletingTaskArr: [] // 正在删除名片的任务列表
    }
  },
  watch: {
    panelStatus(newValue) {
      console.log('panelStatus change', newValue)
      this.clearLoop()
      if (newValue) {
        this.loopTaskRes()
      }
    }
  },
  computed: {
    ...mapState('user', {
      userInfo: state => state.user_info
    })
  },
  methods: {
    init() {
      this.queryTask()
    },
    toogleTaskPanel() {
      this.panelStatus = !this.panelStatus
    },
    createTask(params) {
      this.submitBatchTask(params)
    },
    getStatusText(item) {
      if (!item) return ''
      if (item.status == this.ASYNC_TASK_STATUS.running) {
        return `${item.total - item.unfinished}/${item.total}`
      }
      if (item.status == this.ASYNC_TASK_STATUS.success) {
        return this.$t(this.ASYNC_TASK_MAP[item.type].success, [item.total])
      }
      if (item.status == this.ASYNC_TASK_STATUS.failed) {
        return this.$t(this.ASYNC_TASK_MAP[item.type].error, [
          item.total - item.unfinished || 0,
          item.unfinished || 0
        ])
      }
    },
    delSingleTask(id) {
      this.delete_task([id])
    },
    async delAllTask() {
      try {
        await batch_delete_task({})
        this.panelStatus = false
        this.queryTask()
      } catch (e) {}
    },
    loopTaskRes() {
      this.timer = setTimeout(() => {
        if (this.intervalTimes >= 30) {
          this.panelStatus = false
        } else {
          this.queryTask(() => {
            this.intervalTimes++
            this.loopTaskRes()
          })
        }
      }, this.GAP_INTERVAL)
    },
    clearLoop() {
      clearInterval(this.timer)
      this.timer = null
      this.intervalTimes = 0
    },
    async submitBatchTask(params) {
      try {
        /* bugfix：20230118 调用接口时需要对params.param中的数据进行修改，又不能影响页面中的原始数据，采用拷贝一份数据修改处理 */
        /* 注意不能拷贝params整个对象，因为params参数有循环引用的问题，序列化会报错 */
        const paramInParams = JSON.parse(JSON.stringify(params.param))
        const arr = ['creators', 'tags', 'cloudchecks']
        // bugfix:如果是批量任务，且include_id不为空，则start需要重置为0
        if (Array.isArray(paramInParams.include_id) && paramInParams?.include_id.length > 0) {
          paramInParams.start = 0
        }
        arr.forEach(f => {
          if (Array.isArray(paramInParams[f]) && paramInParams[f].includes(-1)) {
            // -1 代表选项“全部”，但选“全部”时接口传参该字段应该为空数组，所以需将数组中的 -1 去除
            paramInParams[f].splice(paramInParams[f].indexOf(-1), 1)
          }
        })
        const data = await submit_batch_task(
          {},
          {
            filter_data: paramInParams,
            task_data: params.task_data || {},
            count: params.count || 0,
            type: ASYNC_TASK_TYPE[params.type],
            lang: this.$i18n.locale
          }
        )
        if (data.errno == 0) {
          // this.$message.success(this.$t('modify_ok'))
          this.$prettylog.table(data)
          this.queryTask()
          this.panelStatus = true
          params.cb && params.cb()
        } else {
          this.$message.error(this.$t('export_server_busy'))
        }
        if (params.instance) {
          params.instance.confirmButtonLoading = false
          params.done()
        }
      } catch (e) {
        this.$message.error(this.$t(this.$formatErrorTxt(e, 'SyncAPI')))
        if (params.instance) {
          params.instance.confirmButtonLoading = false
          params.done()
        }
      }
    },
    async queryTask(cb) {
      try {
        const data = await async_task_query({})
        let unfinished = 0
        if (data.errno == 0) {
          const { list = [], total = 0, error = 0 } = data.data || {}
          list.map(item => {
            const index = this.deletingTaskArr.findIndex(_task => _task == item.id)
            // 正在运行 || 准备进行的任务
            if (item.status < this.ASYNC_TASK_STATUS.success) {
              unfinished++
              // 判断是否有正在运行的删除名片任务
              if (item.type == this.ASYNC_TASK_TYPE.TYPE_CARD_DELETE && index == -1) {
                this.deletingTaskArr.push(item.id)
              }
            } else if (
              item.status == this.ASYNC_TASK_STATUS.success &&
              item.type == this.ASYNC_TASK_TYPE.TYPE_CARD_DELETE &&
              this.$route.path.indexOf('card/view')
            ) {
              if (index > -1) {
                this.deletingTaskArr.splice(index, 1)
                this.$parent.getTableData()
              }
            }
          })
          this.taskList = [].concat(data.data.list)
          // TEST TO DELETE 预设第一个异步任务失败
          // this.taskList[0].status = ASYNC_TASK_STATUS.failed
          this.error = error || 0
          this.total = total
        } else {
          this.$message.error(this.$t('export_server_busy'))
        }
        this.unfinished = unfinished
        cb && cb(data)
      } catch (e) {
        console.error(e)
        this.$message.error(this.$t(this.$formatErrorTxt(e, 'SyncAPI')))
      }
    },
    async delete_task(id) {
      try {
        const data = await delete_task({}, id)
        if (data.errno != 0) {
          this.$message.error(this.$t('export_server_busy'))
        }
        this.queryTask()
      } catch (e) {
        this.$message.error(this.$t(this.$formatErrorTxt(e, 'SyncAPI')))
      }
    },
    donwloadExcelUrl(id) {
      if (!this.userInfo || !this.userInfo.APIList) return ''
      const url = `${this.userInfo.APIList.SyncAPI[0]}/download_export_excel?token=${getCookie(
        'S2'
      )}&id=${id}`
      return url
    },
    setDeletingStatus(value) {
      this.$store.commit('user/setValue', {
        key: 'isBatchDeleting',
        value
      })
    },
    async showTaskResult(item) {
      console.log('item', item)
      const ref = this.$parent.$refs.taskResultModal || this.$refs.taskResultModal
      // 查询任务结果详情
      // const data = await this.fakeTaskResult(item.id)
      try {
        const data = await view_task_result_detail({
          task_id: item.id
        })
        console.log('data====', data)
        const result = {
          ...item,
          ...data.data
        }
        console.log('result', result)
        ref.visible = true
        // 填充数据
        ref.setResultData(result)
      } catch (e) {}
    },
    fakeTaskResult(id) {
      return new Promise((resolve, reject) => {
        const data = {
          error_data: {
            data: [
              {
                code: 3101,
                data: [
                  1, 3, 4, 5, 6, 7
                  // {
                  //   file_name: 'asflaisdhflauisdkhfasdljf.vcf',
                  //   name: 'test1'
                  // },
                  // {
                  //   file_name: 'asflaisdhflauisdkhfasdljf1.vcf',
                  //   name: 'test2'
                  // }
                ]
              }
            ],
            result_type: 'excel'
          },
          success: 90,
          total: 100,
          invited: 1
        }
        resolve(data)
      })
    }
  },
  mounted() {
    console.log('task component mounted')
    this.init()
    this.$EventBus.$on('query-task', () => {
      this.queryTask()
    })
  }
}
